import { render } from "./Vuex.vue?vue&type=template&id=2f84a93f"
import script from "./Vuex.vue?vue&type=script&lang=js"
export * from "./Vuex.vue?vue&type=script&lang=js"

import "./Vuex.vue?vue&type=style&index=0&id=2f84a93f&lang=css"

import exportComponent from "/Users/lianyue/Project/vue-upload-component/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__